import { useMutation, useQueryClient } from 'react-query';
import Button from '../../../../../../designSystem/Button/Button';
import { SendEmailProspectButtonProps } from './SendEmailProspectButton.types';
import { BaseResponse } from '../../../../../../../types/api/api.types';
import {
  SEND_EMAIL_PROSPECT_QUERY_KEY,
  sendEmailProspectQuery,
} from '../DashboardProspectionsTable.query';

export default ({ prospectId, ...props }: SendEmailProspectButtonProps) => {
  const queryClient = useQueryClient();

  const { mutate: sendEmail, isLoading: isSendingEmail } = useMutation<
    Awaited<BaseResponse>,
    Error,
    number
  >((data) => sendEmailProspectQuery(data), {
    mutationKey: SEND_EMAIL_PROSPECT_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: ({ message }) => {
      alert(message);
    },
    onError: async (error) => alert(error.message),
  });

  return (
    <Button
      style={{
        alignSelf: 'center',
        marginTop: 'var(--spacing-s)',
      }}
      onClick={(e) => {
        e.stopPropagation()
        sendEmail(prospectId)
      }}
      isLoading={isSendingEmail}
      {...props}
    />
  );
};
